import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { Shield } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SSOCallback = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { ssoLogin } = useAuth();
  const [error, setError] = useState(false);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const code = params.get('code');
    const state = params.get('state');
    if (!code || !state) { setError(true); return; }
    axios.post(`${API}/auth/sso/amigos-callback`, { code, state })
      .then((res) => { ssoLogin(res.data.access_token, res.data.user); navigate('/dashboard'); })
      .catch(() => setError(true));
  }, [params, navigate, ssoLogin]);

  if (error) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg-deepest)', padding: '2rem' }}>
        <div style={{ textAlign: 'center', maxWidth: 460, padding: '3rem', background: 'var(--surface)', border: '1px solid var(--border-dim)' }}>
          <Shield size={48} style={{ color: 'var(--texas-red)', marginBottom: '1rem' }} />
          <h1 style={{ fontFamily: 'var(--font-display)', fontSize: '1.5rem', color: 'white', marginBottom: '0.75rem' }}>SIGN-IN LINK EXPIRED</h1>
          <p style={{ color: 'var(--text-secondary)', lineHeight: 1.7, marginBottom: '1.5rem' }}>
            This sign-in link is invalid or has already been used. Please go back to Amigo's dashboard and click "Switch to Lone Star" again.
          </p>
          <a href="/dashboard" style={{ color: 'var(--astros-orange)', textDecoration: 'none', fontWeight: 700 }}>
            Or sign in with your password →
          </a>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg-deepest)' }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ width: 40, height: 40, border: '3px solid var(--astros-orange)', borderTopColor: 'transparent', borderRadius: '50%', animation: 'spin 0.8s linear infinite', margin: '0 auto 1.5rem' }} />
        <p style={{ fontFamily: 'var(--font-display)', fontSize: '1.1rem', color: 'white', letterSpacing: '0.04em' }}>
          COMPLETING SECURE SIGN-IN...
        </p>
        <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem', marginTop: '0.5rem' }}>
          Verifying with Amigo's Bail Bonds
        </p>
      </div>
    </div>
  );
};

export default SSOCallback;
